"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.shouldSetCookie = exports.necessary = exports.marketing = exports.getOptions = exports.expirations = exports.analytics = exports.Cookie = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _expirations, _necessary, _analytics, _marketing;

var Cookie;
exports.Cookie = Cookie;

(function (Cookie) {
  Cookie["AGREED"] = "__kwc_agreed";
  Cookie["SETTINGS"] = "__kwc_settings";
  Cookie["AFFILIATE_ID"] = "SKYPICKER_AFFILIATE";
  Cookie["AFFILIATE_UID"] = "SKYPICKER_AFFILIATE_UID";
  Cookie["AFFILIATE_SUB_PARAM"] = "sub1Param";
  Cookie["CF_DUID"] = "__cfduid";
  Cookie["CF_RUID"] = "__cfruid";
  Cookie["CRITEO_ID"] = "cto_lwid";
  Cookie["CRITEO_ID_COPY"] = "cto_idcpy";
  Cookie["CRITEO_ID_SESSION"] = "cto_sid";
  Cookie["CRITEO_WRITE_TEST"] = "criteo_write_test";
  Cookie["CURRENCY"] = "preferred_currency";
  Cookie["DARWIN_SAVED_GROUPS"] = "__kw_darwin_saved_groups";
  Cookie["DARWIN_SAVED_TESTS"] = "__kw_darwin_saved_tests";
  Cookie["EXPONEA"] = "__inf_etc__";
  Cookie["EXPONEA_TIME"] = "__inf_time2__";
  Cookie["FB_CUSTOMER"] = "_fbc";
  Cookie["FB_PRODUCT"] = "_fbp";
  Cookie["FORCED_BRAND"] = "forced_brand";
  Cookie["FORTER_NCD"] = "ftr_ncd";
  Cookie["FORTER_TOKEN"] = "forterToken";
  Cookie["FORTER_TOKEN_COPY"] = "forterTokenCopy";
  Cookie["FRAME_ANCESTOR_URL"] = "frame_ancestor_url";
  Cookie["GA_CUSTOMER"] = "_gac_UA-66880475-1";
  Cookie["GA_NUMBER"] = "_ga";
  Cookie["GA_TAG"] = "_gat_gtag_UA_29345084_13";
  Cookie["GCL_ADS"] = "_gcl_au";
  Cookie["GCL_CONVERSION"] = "_gcl_aw";
  Cookie["GID"] = "_gid";
  Cookie["GOOGLE_CLICK_ID"] = "google_click_id";
  Cookie["GTM_SPLIT_VAR"] = "gtmSplitVar";
  Cookie["IGNORE_MOBILE_AD"] = "ignore_mobile_ad";
  Cookie["INTENT_MEDIA_PUID"] = "im_puid";
  Cookie["INTENT_MEDIA_PREFS"] = "intent_media_prefs";
  Cookie["INTENT_MEDIA_SNID"] = "im_snid";
  Cookie["OILBOUNCE_VIEWED"] = "viewedOuibounceModal";
  Cookie["PARSELY_VISITOR"] = "_parsely_visitor";
  Cookie["LANGUAGE"] = "preferred_language";
  Cookie["LOGGLY_TRACKING_SESSION"] = "logglytrackingsession";
  Cookie["RECENT_SEARCH"] = "recentSearch";
  Cookie["RISKIFIED_LAST_RUN"] = "lastRskxRun";
  Cookie["RISKIFIED_RUN_COOKIE"] = "rskxRunCookie";
  Cookie["SIMPLE_TOKEN"] = "simpleToken";
  Cookie["TEST_ENVIRONMENT"] = "testEnvironment";
  Cookie["UA_SESSION_TOKEN"] = "ua_session_token";
  Cookie["UI"] = "ui";
  Cookie["UTAG_MAIN"] = "utag_main";
  Cookie["USER_ID"] = "SKYPICKER_VISITOR_UNIQID";
})(Cookie || (exports.Cookie = Cookie = {}));

var EXP_DEFAULT_DAYS = 365 * 4; // Expiration is in days, as used by "js-cookie"

/* eslint-disable no-undefined */

var expirations = (_expirations = {}, _expirations[Cookie.AGREED] = EXP_DEFAULT_DAYS, _expirations[Cookie.SETTINGS] = EXP_DEFAULT_DAYS, _expirations[Cookie.AFFILIATE_ID] = 30, _expirations[Cookie.AFFILIATE_UID] = 30, _expirations[Cookie.AFFILIATE_SUB_PARAM] = 30, _expirations[Cookie.CF_DUID] = undefined, _expirations[Cookie.CF_RUID] = undefined, _expirations[Cookie.CRITEO_ID] = undefined, _expirations[Cookie.CRITEO_ID_COPY] = undefined, _expirations[Cookie.CRITEO_ID_SESSION] = undefined, _expirations[Cookie.CRITEO_WRITE_TEST] = undefined, _expirations[Cookie.CURRENCY] = EXP_DEFAULT_DAYS, _expirations[Cookie.DARWIN_SAVED_GROUPS] = EXP_DEFAULT_DAYS, _expirations[Cookie.DARWIN_SAVED_TESTS] = EXP_DEFAULT_DAYS, _expirations[Cookie.EXPONEA] = EXP_DEFAULT_DAYS, _expirations[Cookie.EXPONEA_TIME] = undefined, _expirations[Cookie.FB_CUSTOMER] = undefined, _expirations[Cookie.FB_PRODUCT] = undefined, _expirations[Cookie.FORCED_BRAND] = EXP_DEFAULT_DAYS, _expirations[Cookie.FORTER_NCD] = EXP_DEFAULT_DAYS, _expirations[Cookie.FORTER_TOKEN] = EXP_DEFAULT_DAYS, _expirations[Cookie.FORTER_TOKEN_COPY] = EXP_DEFAULT_DAYS, _expirations[Cookie.FRAME_ANCESTOR_URL] = EXP_DEFAULT_DAYS, _expirations[Cookie.GA_CUSTOMER] = undefined, _expirations[Cookie.GA_NUMBER] = undefined, _expirations[Cookie.GA_TAG] = undefined, _expirations[Cookie.GCL_ADS] = undefined, _expirations[Cookie.GCL_CONVERSION] = undefined, _expirations[Cookie.GID] = undefined, _expirations[Cookie.GOOGLE_CLICK_ID] = 180, _expirations[Cookie.GTM_SPLIT_VAR] = undefined, _expirations[Cookie.IGNORE_MOBILE_AD] = undefined, _expirations[Cookie.INTENT_MEDIA_PUID] = undefined, _expirations[Cookie.INTENT_MEDIA_PREFS] = undefined, _expirations[Cookie.INTENT_MEDIA_SNID] = undefined, _expirations[Cookie.LANGUAGE] = EXP_DEFAULT_DAYS, _expirations[Cookie.LOGGLY_TRACKING_SESSION] = undefined, _expirations[Cookie.OILBOUNCE_VIEWED] = undefined, _expirations[Cookie.PARSELY_VISITOR] = undefined, _expirations[Cookie.RECENT_SEARCH] = 30, _expirations[Cookie.RISKIFIED_LAST_RUN] = undefined, _expirations[Cookie.RISKIFIED_RUN_COOKIE] = undefined, _expirations[Cookie.SIMPLE_TOKEN] = 1 / 24, _expirations[Cookie.TEST_ENVIRONMENT] = EXP_DEFAULT_DAYS, _expirations[Cookie.UA_SESSION_TOKEN] = 30, _expirations[Cookie.UI] = undefined, _expirations[Cookie.USER_ID] = EXP_DEFAULT_DAYS, _expirations[Cookie.UTAG_MAIN] = undefined, _expirations);
/* eslint-enable no-undefined */

exports.expirations = expirations;
var necessary = (_necessary = {}, _necessary[Cookie.AGREED] = true, _necessary[Cookie.SETTINGS] = true, _necessary[Cookie.AFFILIATE_ID] = true, _necessary[Cookie.AFFILIATE_UID] = true, _necessary[Cookie.CF_DUID] = true, _necessary[Cookie.CF_RUID] = true, _necessary[Cookie.CURRENCY] = true, _necessary[Cookie.FORCED_BRAND] = true, _necessary[Cookie.FORCED_BRAND] = true, _necessary[Cookie.FORTER_NCD] = true, _necessary[Cookie.FORTER_TOKEN] = true, _necessary[Cookie.FORTER_TOKEN_COPY] = true, _necessary[Cookie.FRAME_ANCESTOR_URL] = true, _necessary[Cookie.IGNORE_MOBILE_AD] = true, _necessary[Cookie.LANGUAGE] = true, _necessary[Cookie.OILBOUNCE_VIEWED] = true, _necessary[Cookie.RECENT_SEARCH] = true, _necessary[Cookie.RISKIFIED_LAST_RUN] = true, _necessary[Cookie.RISKIFIED_RUN_COOKIE] = true, _necessary[Cookie.SIMPLE_TOKEN] = true, _necessary[Cookie.TEST_ENVIRONMENT] = true, _necessary[Cookie.UA_SESSION_TOKEN] = true, _necessary[Cookie.USER_ID] = true, _necessary[Cookie.UI] = true, _necessary);
exports.necessary = necessary;
var analytics = (_analytics = {}, _analytics[Cookie.EXPONEA] = true, _analytics[Cookie.EXPONEA_TIME] = true, _analytics[Cookie.GA_CUSTOMER] = true, _analytics[Cookie.GA_NUMBER] = true, _analytics[Cookie.GA_TAG] = true, _analytics[Cookie.GCL_ADS] = true, _analytics[Cookie.GCL_CONVERSION] = true, _analytics[Cookie.GID] = true, _analytics[Cookie.GOOGLE_CLICK_ID] = true, _analytics[Cookie.GTM_SPLIT_VAR] = true, _analytics[Cookie.LOGGLY_TRACKING_SESSION] = true, _analytics[Cookie.PARSELY_VISITOR] = true, _analytics[Cookie.UTAG_MAIN] = true, _analytics);
exports.analytics = analytics;
var marketing = (_marketing = {}, _marketing[Cookie.CRITEO_ID] = true, _marketing[Cookie.CRITEO_ID_COPY] = true, _marketing[Cookie.CRITEO_ID_SESSION] = true, _marketing[Cookie.CRITEO_WRITE_TEST] = true, _marketing[Cookie.EXPONEA] = true, _marketing[Cookie.EXPONEA_TIME] = true, _marketing[Cookie.FB_CUSTOMER] = true, _marketing[Cookie.FB_PRODUCT] = true, _marketing[Cookie.INTENT_MEDIA_PUID] = true, _marketing[Cookie.INTENT_MEDIA_PREFS] = true, _marketing[Cookie.INTENT_MEDIA_SNID] = true, _marketing);
exports.marketing = marketing;

var getOptions = function getOptions(key, opts) {
  if (opts === void 0) {
    opts = {};
  }

  return (0, _extends2.default)({
    secure: true
  }, opts, {
    expires: expirations[key]
  });
};

exports.getOptions = getOptions;

var shouldSetCookie = function shouldSetCookie(key, settings) {
  var shouldSetAnalytics = key in analytics && settings.analytics;
  var shouldSetMarketing = key in marketing && settings.marketing;
  return shouldSetAnalytics || shouldSetMarketing;
};

exports.shouldSetCookie = shouldSetCookie;